"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvFromHost = exports.isLocalEnvironment = void 0;
var utils_isomorphic_1 = require("@clover-microapp/utils-isomorphic");
function isLocalEnvironment() {
    return utils_isomorphic_1.ENV_PATTERNS.DEV_LOCAL.test(location.hostname);
}
exports.isLocalEnvironment = isLocalEnvironment;
function getEnvFromHost() {
    var env = isLocalEnvironment() ? 'dev1' : location.hostname.split('.')[0];
    if (env === 'sandbox')
        return 'sandboxprod';
    if (env === 'www') {
        var region = location.hostname.split('.')[1];
        env = "prod-".concat(region === 'clover' ? 'na' : region);
    }
    return env;
}
exports.getEnvFromHost = getEnvFromHost;
//# sourceMappingURL=environments.js.map